import React from "react";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reuseable/Spinner";
import usePaginationState from "../../customHooks/usePaginationHook";
import { toast } from "react-toastify";
const EditCustomerComponent = loadable(
  () => import("../../components/Customer/EditCustomer")
);
type Props = {};

const EditCustomer = (props: Props) => {
  const { id } = useParams();
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const { data: singleCustomer, isPending: singleCustomerLoading } = useGetHook(
    {
      queryKey: [`customer-${id}`],
      url: `${APIS.CUSTOMER}${id}/`,
      params: {},
    }
  );
  const { data: customerData, isPending: customerDataLoading } = useGetHook({
    queryKey: [
      `customerDetails-${id}-${pageSize}-${offset}`,
    ],
    url: `${APIS.CUSTOMER_DETAILS}`,
    params: {
      order__customer: id ?? "",
      limit: pageSize,
      offset: offset,
    },
  });
  const {
    isLoading,
    mutateAsync: updateCustomerAsync,
    data,
  } = usePatchHook({
    queryKey: [`customer`, `customer-${id}`],
    navigateURL: "/customer",
    message: false
  });
  const handleUpdateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}${id}/`;
    const formData = {
      name: values.title,
      address: values.address,
      contact_number: values.contact_number,
      email: values.email,
    };
    try {
      const res = await updateCustomerAsync({ url, formData, setError });
      console.log(res)
      if (res?.status === 200) {
        toast.success("Updated Customer successfully");
      } else {
        toast.error("Updated Failed");

      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {singleCustomerLoading ? (
        <Spinner />
      ) : (
        <EditCustomerComponent
          singleCustomer={singleCustomer}
          handleUpdateCustomer={handleUpdateCustomer}
          isLoading={isLoading}
          customerData={customerData}
          pageSize={pageSize}
          setPageSize={setPageSize}
          offset={offset}
          setOffset={setOffset}
          customerDataLoading={customerDataLoading}
        />
      )}
    </>
  );
};

export default EditCustomer;
